<template>
  <Wrapper
    v-show="
      !preview && renderTools &&
      !['reheight_widget', 'remargin_widget', 'sort_widget', 'reheight_grid', 'remargin_grid', 'reheight_component'].includes(mode) &&
      slideContainerHover.id &&
      slideContainerHover.id != slideContainerActive.id
    "
    :position="slideContainerHover.position"
    class="slide-container-hover"
    id="slide-container-hover-frame"
    :class="{'top': !isOverScroll, 'bottom': isOverScroll}"
    @click="click"
    style="cursor: pointer;"
  >
    <div>
      <Legend class="lbl-name" style="color: #12A9FF;">
        Container
      </Legend>
      <!-- <pre>{{ cellHover }}</pre> -->
    </div>
  </Wrapper>
</template>

<script>
import { mapGetters } from "vuex";
import { Wrapper, Legend } from "./SlideContainerHover.styled";
export default {
  components: {
    Wrapper,
    Legend,
  },
  data() {
    return {
      positionTool: "top",
      topElementPosition: 0,
    }
  },
  watch: {
    scrollPosition() {
      this.$store.dispatch("designIframe/component/setComponentAction", {
        component_id: this.slideContainerHover.id,
        type: "SLIDE_CONTAINER",
        action: "HOVER",
      });
    },
    mode() {
      this.$nextTick(function () {
        this.$store.dispatch("designIframe/component/setComponentAction", {
          component_id: this.slideContainerHover.id,
          type: "SLIDE_CONTAINER",
          action: "HOVER",
        });
      });
    },
    cellHover: {
      deep: true,
      handler() {
        const element = document.getElementById("slide-container-hover-frame")
        if(element) {
          this.$nextTick(() => {
            this.topElementPosition = element.offsetTop;
          })
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      preview: "designIframe/preview",
      renderTools: "designIframe/frame/renderTools",
      widgetHover: "designIframe/frame/widgetHover",
      slideSectionActive: "designIframe/frame/slideSectionActive",
      slideContainerHover: "designIframe/frame/slideContainerHover",
      slideContainerActive: "designIframe/frame/slideContainerActive",
      mode: "designIframe/mode",
      scrollPosition: "scrollPosition",
      components: "designIframe/metadata/components",
    }),
    slide_page_key() {
      return this.slideContainerHover.id && Object.keys(this.components).find((key) =>
        this.components[key].componentsID && this.components[key].componentsID.includes(this.slideContainerHover.id)
      );
    },
    isOverScroll() {
      this.scrollPosition;
      const diff = this.scrollPosition - this.topElementPosition;
      if (diff >= 0) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    click() {
      if (this.slideContainerHover.id && this.slide_page_key) {
        this.$store.dispatch("designIframe/frame/setWidgetActive", {})
        this.$store.dispatch("designIframe/frame/setWidgetHover", {})
        this.$store.dispatch("designIframe/component/elActive", {
          elementID: ["component", this.slideContainerHover.id],
        });
        this.$store.dispatch("designIframe/frame/setSlideContainerActive", {
          component_id: this.slideContainerHover.id,
        });
      }
      this.$store.dispatch("designIframe/frame/setFloatFrameActive", {});
      this.$store.dispatch("designIframe/frame/setFloatFrameHover", {});
      this.$store.dispatch("designIframe/frame/setSectionHover", {});
      
      this.$store.dispatch("designIframe/frame/setSectionActive", {});
      this.$store.dispatch("designIframe/frame/setSlideSectionActive", {
        component_id: this.section_key,
        index: this.index_slide,
      });
    }
  },
};
</script>

<style lang="scss">
</style>